<template>
  <div class="settings">
    <panel width="300" title="Company" class="company">
      <div class="options">
        <button class="save" @click="updateCompany"><i class="far fa-save"></i></button>
      </div>
      <input-group name="company-name" displayName="Name" placeholder="Name" v-model="company.name"></input-group>
      <input-group name="company-street" displayName="Street" placeholder="Street" v-model="company.street"></input-group>
      <input-group name="company-house-number" displayName="House Number" placeholder="House Number" v-model="company.houseNumber"></input-group>
      <input-group name="company-postal-code" displayName="Postal Code" placeholder="Postal Code" v-model="company.postalCode"></input-group>
      <input-group name="company-city" displayName="City" placeholder="City" v-model="company.city"></input-group>
      <input-group name="company-country" displayName="Country" placeholder="Country" v-model="company.country"></input-group>
      <input-group name="company-account" displayName="Account" placeholder="Account" v-model="company.account"></input-group>
      <input-group name="company-vat" displayName="VAT" placeholder="VAT" v-model="company.vat"></input-group>
      <input-group name="company-email" displayName="Email" placeholder="Email" v-model="company.email"></input-group>
      <input-group name="company-phone" displayName="Phone" placeholder="Phone" v-model="company.phone"></input-group>
      <input-group name="company-fax" displayName="Fax" placeholder="Fax" v-model="company.fax"></input-group>
      <input-group name="company-website" displayName="Website" placeholder="Website" v-model="company.website"></input-group>
      <input-group name="company-legal" displayName="Legal" placeholder="Legal" v-model="company.legal"></input-group>
    </panel>

    <panel width="300" title="Theming" class="theming" v-if="theming">
      <div class="options">
        <button class="save" @click="updateTheming"><i class="far fa-save"></i></button>
      </div>
      <div class="input-color-picker-group">
        <label>Theme Color</label>
        <chrome-color-picker v-model="theming.colorTheme"></chrome-color-picker>
      </div>
      <div class="input-color-picker-group">
        <label>Invoice Theme Color</label>
        <chrome-color-picker v-model="theming.colorInvoiceTheme"></chrome-color-picker>
      </div>
    </panel>


    <panel width="300" title="Templates" class="templates">
      <div v-if="templates" class="template-items">
        <div v-for="(template, index) in templates" class="template" :key="index">
          <div class="name">{{template.name}}</div>
          <div class="ref">{{template.id}}</div>
          <div class="version">{{template.version}}</div>
          <div class="delete" @click="deleteTemplate(template)">Delete</div>
        </div>
      </div>

      <div class="add-template">
        <div class="message" v-if="message">{{message}}</div>
        <input-group name="template-name" displayName="Name" placeholder="Name" v-model="newTemplateName"></input-group>
        <div>
          <input type="file" id="file" ref="file" v-on:change="addFile()"/>
        </div>
        <button @click="uploadTemplate()">Upload template</button>
      </div>
    </panel>
  </div>
</template>

<script>
import { Chrome } from "vue-color"
import InputGroup from "@/components/inputs/InputGroup"
import Panel from "@/components/layout/Panel"
export default {
  name: "settings",
  components: {
    InputGroup,
    Panel,
    'chrome-color-picker': Chrome,
  },
  data() {
    return {
      currentUser: this.$store.getters.currentUser,
      templates: this.$store.getters.orgTemplates,
      file: null,
      message: null,
      newTemplateName: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company
    },
    theming() {
      return this.$store.getters.theming
    },
  },
  methods: {
    updateColorTheme() {},
    updateCompany() {
      this.$store.dispatch('updateCompany', this.company)
    },
    updateTheming() {
      this.$store.dispatch('updateTheming', this.theming)
      document.querySelector(':root').style.setProperty('--color-theme', this.theming.colorTheme.hex);
      document.querySelector(':root').style.setProperty('--color-invoice-theme', this.theming.colorInvoiceTheme.hex);
      document.querySelector(':root').style.setProperty('--color-invoice-theme-values', `${this.theming.colorInvoiceTheme.rgba.r}, ${this.theming.colorInvoiceTheme.rgba.g}, ${this.theming.colorInvoiceTheme.rgba.b}`);
      document.querySelector(':root').style.setProperty('--color-theme-values', `${this.theming.colorTheme.rgba.r}, ${this.theming.colorTheme.rgba.g}, ${this.theming.colorTheme.rgba.b}`);
    },
    addFile() {
      this.file = this.$refs.file.files[0]
    },
    uploadTemplate() {
      if (this.newTemplateName) {
        if (this.file) {
          this.$store.dispatch('addOrganisationTemplate', {file: this.file, name: this.newTemplateName, organisation: this.$store.getters.currentUser.organisation})
        } else {
          this.message = "No file selected yet"
        }
      } else {
        this.message = "Please choose a name for you template"
      }
    },
    deleteTemplate(template) {
      this.$store.dispatch('deleteTemplate', template)
    }
  }
};
</script>

<style lang="scss">
.input-color-picker-group {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  label {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.settings {
  display: flex;
  margin-top: 30px;
}
.panel {
  &:first-child {
    margin-left: 10px;
  }
  margin-right: 10px;
}

.add-template {
  border: 1px solid red;
  margin: 24px 0;
  padding: 16px;
}

.templates {
  .template-items {
    .template {
      box-shadow: 0 1px 4px rgba(0,0,0,0.2);
      margin-bottom: 16px;
      padding: 16px;
      border-radius: 4px;
      .ref {
        font-size: 12px;
      }
    }
  }
}
</style>
